import { inject, Injectable } from '@angular/core'

import { sortBy } from 'lodash-es'
import { firstValueFrom, map, shareReplay, takeUntil } from 'rxjs'

import { Memoize } from '@ti/core/common/decorators'
import { injectDestroy$ } from '@ti/core/common/utils'

import { GroupsStore } from './groups.store'

@Injectable({ providedIn: 'root' })
export class GroupsOptionsProvider {
  protected readonly groupsStore = inject(GroupsStore)
  protected readonly destroy$ = injectDestroy$()

  @Memoize()
  public get filterOptions$() {
    return this.groupsStore.state$.items.pipe(
      takeUntil(this.destroy$),
      map((groups) => {
        return sortBy(
          groups.map((group) => ({ label: group.name, value: group.id })) ?? [],
          'label',
        )
      }),
      shareReplay({ bufferSize: 1, refCount: false }),
    )
  }

  @Memoize()
  public get selectOptions$() {
    return this.groupsStore.state$.items.pipe(
      takeUntil(this.destroy$),
      map((groups) => {
        return Array.isArray(groups)
          ? sortBy(
              groups.map((group) => ({ label: group.name, value: group.id })),
              'label',
            )
          : []
      }),
      shareReplay({ bufferSize: 1, refCount: false }),
    )
  }

  // The store starts empty until its first load, so reading it earlier would offer no groups
  public async getFilterOptions() {
    await this.groupsStore.ensureIsFresh()
    return firstValueFrom(this.filterOptions$)
  }

  public async getSelectOptions() {
    await this.groupsStore.ensureIsFresh()
    return firstValueFrom(this.selectOptions$)
  }
}
